import React, { useState, useEffect, useRef } from "react";
import axiosInstance from '../axiosInstance';
import { FaSearch, FaPen, FaPlus } from "react-icons/fa";
import { RiDeleteBin6Line } from "react-icons/ri";
import { API_URL_All } from "../api";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import * as general from '../libs/general';
import Paging from '../components/Paging';
import AdLayout from '../components/AdLayout';
import DataTable from '../components/ui/DataTable';
import { fetchPriceLevelPermissions } from "../libs/customerCreatePermission";

/** embedded: hiển thị trong tab của trang Quản lý khách hàng (không bọc AdLayout). */
const Levels = ({ embedded = false }) => {
  const [pageData, setPageData] = useState({ content: [] });
  const [message, setMessage] = useState("");
  const hasRun = useRef(false);
  const [isLoading, setIsLoading] = useState(false);

  const [searchQuery, setSearchQuery] = useState("");
  const navigate = useNavigate();
  const [levelFeaturePerm, setLevelFeaturePerm] = useState({
    loaded: false,
    canView: false,
    canCreate: false,
    canEdit: false,
    canDelete: false,
  });


  useEffect(() => {
    let cancelled = false;
    (async () => {
      const p = await fetchPriceLevelPermissions(axiosInstance);
      if (cancelled) return;
      setLevelFeaturePerm({
        loaded: true,
        canView: Boolean(p?.canView),
        canCreate: Boolean(p?.canCreate),
        canEdit: Boolean(p?.canEdit),
        canDelete: Boolean(p?.canDelete),
      });
      if (p?.canView) {
        searchLevels();
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  const handleChangeItemsPerPage = (e) => {
    const newItemsPerPage = parseInt(e.target.value, 10);
    searchLevels({ page: 0, size: newItemsPerPage });
  };

  const handlePageChange = (page) => {
    searchLevels({ page: page - 1 });
  };
  const handleSearchChange = (e) => {
    var searchValue = e.target.value;
    searchLevels({ page: 0, keyword: searchValue });
    setSearchQuery(e.target.value);
  };

  const handleDeleteLevel = (item) => {
    general.openConfirm(async () => {
      try {
        const response = await axiosInstance.post(`/api/levels/deleteLevel/${item.id}`);
        if (!response.data.success) {
          toast.error(response.data.message);
          return;
        }
        toast.success(response.data.message);
        searchLevels();
      } catch (error) {
        console.error(error);
        toast.error(error.message);
      }
    });
  };

  const searchLevels = async (filter) => {
    if (levelFeaturePerm.loaded && !levelFeaturePerm.canView) return;
    if (window.calling) return;
    window.calling = true;
    setIsLoading(true);
    setMessage('');
    var params = general.getSession('search_levels');

    var formData = general.getFormData('.form_filter');
    Object.assign(params, formData);

    if (!hasRun.current) {
      hasRun.current = true;
      var oldParams = general.getSession('search_levels');
      Object.assign(params, oldParams);
    }

    if (filter) Object.assign(params, filter);
    general.setSession('search_levels', params);
    window.initializeFilterValue(params);

    var filteredParams = Object.fromEntries(Object.entries(params).filter(([key, v]) => v !== undefined && v !== '' && key + v !== 'page0' && key + v !== 'size550' && key + v !== 'isDeletedfalse'));

    var response = {};
    try {
      response = await axiosInstance.get('/api/levels/searchLevels', { params: filteredParams });
      setPageData(response.data);
    } catch (error) {
      setPageData({ content: [] });
      setMessage(error.message);
      console.error(error);
    } finally {
      window.calling = false;
    }
    setIsLoading(false);
  };

  const body = (
    <>
        {levelFeaturePerm.loaded && !levelFeaturePerm.canView ? (
          <div className="container-fluid p-3 p-md-4">
            <div className="alert alert-warning mb-0">Bạn không có quyền truy cập màn hình này.</div>
          </div>
        ) : (
        <div className="table-responsive web-table customer-management-page customer-mgmt-screen">
          <div className="container-fluid">
            <div className="row bg-dark align-items-center">
              <div className="col-12 col-md-7 order-3 order-md-1 py-1 d-flex align-items-center">
                <div className="flex-start gap-2">
                  {levelFeaturePerm.loaded && levelFeaturePerm.canCreate && (
                    <button className="btn btn-success btn-sm" onClick={() => navigate(`/level`)} title="Thêm bảng giá">
                      <FaPlus /> Thêm mới
                    </button>
                  )}
                </div>
              </div>
              <div className="col-7 col-md-2 pt-1 pb-1 fw-bold text-white text-uppercase d-flex align-items-center justify-content-star title-ad order-1 order-md-2">
                Bảng giá
              </div>
              <div className="col-5 col-md-3 py-1 order-2 order-md-3 d-flex justify-content-end align-items-center">
                <form className="form_filter mb-0 w-auto">
                  <div className="input-group search-block flex-nowrap">
                    <input name="keyword"
                      type="text"
                      className="form-control form-control-sm"
                      placeholder="Tìm kiếm..."
                      value={searchQuery}
                      onChange={(e) => handleSearchChange(e)}  // Ensure `e` is passed to the function
                    />
                    <button className="btn btn-light btn-sm" type="button" title="Tìm kiếm..." onClick={(event) => searchLevels({ page: 0 })}>
                      <FaSearch />
                    </button>
                  </div>
                </form>
              </div>
            </div>


          </div>

          <section className="customer-mgmt-screen__table">
            <DataTable maxHeight="calc(100vh - 160px)" className="table-normal" data-loading={isLoading}>
              <table className="table table-striped table-bordered">
                <thead className="table-primary">
                  <tr>
                    <th width="30px" className="sticky">STT</th>
                    <th>Mã</th>
                    <th>Tên</th>
                    <th>Số lượng</th>
                    <th width="200px"><span>Ngày</span></th>
                    <th width="100px" className="text-center">Thao tác</th>
                  </tr>
                </thead>
                <tbody>
                  {pageData.page && pageData.page.content && pageData.page.content.map((item, index) => (
                    <tr key={item.id}>
                      <td className="sticky">{(pageData.page.number * pageData.page.size) + index + 1}</td>
                      <td className="text-start">
                        <button
                          type="button"
                          className="btn btn-link p-0 text-start text-decoration-none"
                          style={{ color: "#485766" }}
                          onClick={() => navigate(`/level/${item.id}`)}
                          title={levelFeaturePerm.canEdit ? "Cập nhật" : "Xem chi tiết"}
                        >
                          {item.code}
                        </button>
                      </td>
                      <td className="text-start">
                        <button
                          type="button"
                          className="btn btn-link p-0 text-start text-decoration-none"
                          style={{ color: "#485766" }}
                          onClick={() => navigate(`/level/${item.id}`)}
                          title={levelFeaturePerm.canEdit ? "Cập nhật" : "Xem chi tiết"}
                        >
                          {item.name}
                        </button>
                      </td>
                      <td className="text-center">{item.users.length}</td>
                      <td><span title={general.formatDateTime(item.insertTime)}></span> {general.formatDate(item.insertTime)}</td>

                      <td className="text-center align-middle">
                        {levelFeaturePerm.canView && (
                          <div>
                            <FaPen
                              className={`me-2 ${levelFeaturePerm.canEdit ? "text-primary" : "text-secondary"}`}
                              onClick={() => navigate(`/level/${item.id}`)}
                              size={15}
                              title={levelFeaturePerm.canEdit ? "Cập nhật" : "Xem chi tiết"}
                            />
                            {levelFeaturePerm.canDelete && (
                              <RiDeleteBin6Line
                                className="text-danger"
                                role="button"
                                onClick={() => handleDeleteLevel(item)}
                                size={16}
                                title="Xóa"
                              />
                            )}
                          </div>
                        )}
                      </td>
                    </tr>
                  ))}

                  {message === '' && pageData.page && pageData.page.content.length === 0 && (
                    <tr>
                      <td colSpan="6" className="text-center">Không tìm thấy dữ liệu</td>
                    </tr>
                  )}
                  {message !== '' && (
                    <tr>
                      <td colSpan="6" className="text-center">{message}</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </DataTable>
          </section>
          <div className="customer-mgmt-screen__footer d-flex justify-content-end align-items-center">
            <Paging
              pageData={pageData}
              onPageChange={handlePageChange}
              onItemsPerPageChange={handleChangeItemsPerPage}
            />
          </div>
        </div>
        )}
    </>
  );

  if (embedded) return body;
  return (
    <div>
      <AdLayout>{body}</AdLayout>
    </div>
  );
}
export default Levels;